import React from 'react';
import { useShopify } from '../hooks/useShopify';
import { useToast } from './ui/use-toast';

interface PublishToShopifyButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  storeName: string;
  productId: string;
  documentId: string; // Add documentId for Firestore
  title: string;
  description: string;
  bulletPoints: string[];
  pageTitle?: string;
  metaDescription?: string;
  className?: string;
  onPublishComplete?: () => void;
}

export const PublishToShopifyButton: React.FC<PublishToShopifyButtonProps> = ({
  storeName,
  productId,
  documentId,
  title,
  description,
  bulletPoints,
  pageTitle,
  metaDescription,
  className = '',
  onPublishComplete,
  children,
  ...props
}) => {
  const { publishToShopify, isLoading } = useShopify();
  const { toast } = useToast();

  const handleClick = async () => {
    try {
      await publishToShopify(
        storeName,
        productId,
        documentId,
        title,
        description,
        bulletPoints,
        pageTitle,
        metaDescription
      );
      toast({
        title: "Success!",
        description: "Successfully published to Shopify",
        variant: "success",
      });
      onPublishComplete?.();
    } catch (err) {
      console.error('Failed to publish to Shopify:', err);
      toast({
        title: "Error",
        description: err instanceof Error ? err.message : 'Failed to publish to Shopify',
        variant: "destructive",
      });
    }
  };

  return (
    <button
      onClick={handleClick}
      disabled={isLoading}
      className={`${children ? className : `px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:bg-gray-400`} ${className}`}
      {...props}
    >
      {isLoading ? 'Publishing...' : children || 'Publish to Shopify'}
    </button>
  );
};
